import axiosInstance from "../config/axiosInstance";
import { API_ENDPOINTS } from "../config/api";

export const getConnectionTypeList = () =>
  axiosInstance.get(API_ENDPOINTS.getConnectionTypeList);
